import styled from 'styled-components'

export const Wrapper = styled.div<{ width?: string }>`
  width: ${props => props.width};
  border-radius: 16px;
  border: 1px solid ${props => props.theme.colors.borderColor};
  overflow: hidden;
`

export const Head = styled.div`
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 20px;
  background-color: ${props => props.theme.colors.settingField};
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};
  font-size: 14px;
  font-weight: ${props => props.theme.weights.medium};
  color: ${props => props.theme.colors.darkText};
`
